import { render } from "./JoinVip.vue?vue&type=template&id=36546d38&scoped=true"
import script from "./JoinVip.vue?vue&type=script&lang=js"
export * from "./JoinVip.vue?vue&type=script&lang=js"

import "./JoinVip.vue?vue&type=style&index=0&id=36546d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36546d38"]])

export default __exports__